import { Box, Typography } from '@mui/material';
import React from 'react';

import colors from '../../../../constants/colors';

interface PaymentStatusChipProps {
  failed: boolean;
}

const PaymentStatusChip = ({ failed }: PaymentStatusChipProps) => {
  return (
    <Box
      sx={{
        px: 1,
        py: 0.5,
        borderRadius: 1,
        backgroundColor: failed ? colors.csaaRed10 : colors.csaaGreen10,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          lineHeight: '16px',
          letterSpacing: 0.2,
          color: colors.csaaDark,
          fontFamily: 'Cabin',
          fontKerning: 'normal',
          fontWeight: 500,
        }}
      >
        {failed ? 'Failed' : 'Submitted'}
      </Typography>
    </Box>
  );
};

export default PaymentStatusChip;
